"use strict";
//Class generated from template src/main/resources/template/javascript/ClientBuilderTemplate.vm
Object.defineProperty(exports, "__esModule", { value: true });
exports.GaiaClientBuilder = void 0;
var __1 = require("..");
var GaiaClient_1 = require("./GaiaClient");
var GaiaClientBuilder = /** @class */ (function () {
    function GaiaClientBuilder(transporter) {
        this.contentType = 'application/json';
        this.transporter = transporter;
    }
    GaiaClientBuilder.http = function (url) {
        return new GaiaClientBuilder(new __1.HttpTransporter(url));
    };
    GaiaClientBuilder.prototype.withCredentials = function (credentials) {
        this.credentials = credentials;
        return this;
    };
    GaiaClientBuilder.prototype.withContentType = function (contentType) {
        this.contentType = contentType;
        return this;
    };
    GaiaClientBuilder.prototype.build = function () {
        var options = new __1.ClientOptions(this.credentials, this.contentType);
        return new GaiaClient_1.GaiaClient(options, this.transporter);
    };
    return GaiaClientBuilder;
}());
exports.GaiaClientBuilder = GaiaClientBuilder;
//# sourceMappingURL=GaiaClientBuilder.js.map